module.exports = __webpack_public_path__ + "static/img/contant_1.7b5b3f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_1.jpg
// module id = 7bee
// module chunks = 0